import { dashBoardReportPageMapping, defaultFilterMapping } from "@utils/constants";
import { forEach} from "lodash";
import create, { SetState, StateCreator, StoreApi } from "zustand";

interface GenericTableStore {
  filteredInfo: any;
  setFilteredInfo: (x: any) => void;
  topFilters: any;
  settopFilters: (x: any) => void;
  tableParams: any;
  setTableParams: (x: any) => void;
  showFilters: boolean;
  setShowFilters: (x: any) => void;
  data : any[];
  setData : (x: any) => void;
  clearStore: () => void;
}

const getInitialFilterValue = () => {
  let _data : any = {};
  forEach(Object.keys(dashBoardReportPageMapping) , (val) => {
        _data[val] = defaultFilterMapping[val] || {}
  })

  return _data
}

let store: StateCreator<GenericTableStore, [], [], GenericTableStore> | StoreApi<GenericTableStore> = (set: SetState<GenericTableStore>) => ({
  filteredInfo: getInitialFilterValue(),
  setFilteredInfo: (x) => {
    set((state) => ({ filteredInfo: {...state.filteredInfo , ...x} }));
  },
  topFilters: {},
  settopFilters: (x) => {
    set((state) => ({ topFilters: x }));
  },
  tableParams: {
    pagination: {
      current: 1,
      pageSize: 10,
    },
  },
  setTableParams: (x) => {
    set((state) => ({ tableParams: x }));
  },
  showFilters: false,
  setShowFilters: (x) => {
    set((state) => ({ showFilters: x }));
  },
  data : [],
  setData: (x) => {
    set((state) => ({ data: x }));
  },
  clearStore: () => {
    set(() => ({
      filteredInfo: getInitialFilterValue(),
      topFilters: {},
      tableParams: {
        pagination: {
          current: 1,
          pageSize: 10,
        },
      },
      showFilters: false,
      data : []
    }));
  },
});

export const useGenericTableStore = create(store);
